<template>
  <div class="adm-empty">
    <component :is="icon" :size="26" class="adm-empty__icon" />
    <p class="adm-empty__msg">{{ message }}</p>
    <p v-if="hint" class="adm-muted">{{ hint }}</p>
    <slot />
  </div>
</template>

<script>
/** Estado vacío reutilizable — plan 27_09_2026 §4.2. */
import { Inbox } from 'lucide-vue-next';

export default {
  name: 'AdmEmptyState',
  props: {
    message: { type: String, default: 'No hay registros para mostrar.' },
    hint: { type: String, default: '' },
    icon: { type: [Object, Function], default: () => Inbox },
  },
};
</script>

<style scoped>
.adm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  padding: 1.5rem 1rem;
  text-align: center;
  color: var(--color-text);
}

.adm-empty__icon { color: var(--adm-border-strong); }

.adm-empty__msg {
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--adm-font-base);
}
</style>
